import React from 'react';
import { Paginator } from 'primereact/paginator';
import styles from './Paginacao.module.css';

export default function Paginacao({ pagina, porPagina, total, opcoesPorPagina = [15, 25, 50, 100], onMudar }) {
    if (total <= 0) return null;

    return (
        <Paginator
            first={(pagina - 1) * porPagina}
            rows={porPagina}
            totalRecords={total}
            rowsPerPageOptions={opcoesPorPagina}
            onPageChange={(evento) => onMudar({ pagina: Math.floor(evento.first / evento.rows) + 1, porPagina: evento.rows })}
            className={styles.container}
            template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
            currentPageReportTemplate="{first} a {last} de {totalRecords} registros"
        />
    );
}
